import * as React from 'react'

import { useEnterpriseContext } from '@thg-commerce/enterprise-core'
import { productDescription } from '@thg-commerce/enterprise-network/src/transformers/product/description'
import { ResponsiveBuildYourOwnBundleResolverType } from '@thg-commerce/enterprise-network/src/ApolloProvider/resolvers/Types/ResponsiveBuildYourOwnBundleResolver'

import {
  BuildYourOwnBundle,
  BuildYourOwnBundleProps,
} from '@thg-commerce/widget-build-your-own-bundle'

import { BaseWidgetProps } from '../types'

export type BuildYourOwnBundleRendererProps = BaseWidgetProps &
  ResponsiveBuildYourOwnBundleResolverType

export const BuildYourOwnBundleRenderer = (props: BuildYourOwnBundleProps) => {
  const {
    appConfig: { productDescriptionKeys },
  } = useEnterpriseContext()

  if (!props.banners.length) return null

  const buildYourOwnBundleProps: BuildYourOwnBundleProps = {
    showBundlePageTitle: props.showBundlePageTitle,
    bundleSubTitle: props.bundleSubTitle,
    summaryAmount: props.summaryAmount,
    unlimitedProducts: props.unlimitedProducts,
    expandAllCategories: props.expandAllCategories,
    maxProducts: props.maxProducts,
    showInfoButton: props.showInfoButton,
    showProductReviews: props.showProductReviews,
    showProductRRP: props.showProductRRP,
    banners: props.banners.map((banner) => ({
      ...banner,
      skuList: banner.skuList.map((sku) => ({
        ...sku,
        productDescription: productDescription(
          sku.product,
          productDescriptionKeys,
        ),
        product: {
          reviews: sku.product.reviews,
          images: sku.product.images,
        },
      })),
    })),
    showPrices: props.showPrices,
    summaryDisplayType: props.summaryDisplayType,
    showCategoriesList: props.showCategoriesList,
  }

  return <BuildYourOwnBundle {...buildYourOwnBundleProps} />
}
